import { showErrorToast } from "src/components/AlertToastify/AlertToastify";

export const sendEspnCode = async (email: string, accessToken: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/send-espn-code`;
    const data = { email };

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error("Failed to send ESPN code. Please try again.");
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("Error sending ESPN code:", error);
    showErrorToast(error.message || "Something went wrong while trying to send the ESPN code");
    throw error;
  }
};
